const onboardingFormData = [
  {
    id: 1,
    step: '1',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 1 - Osobné údaje',
  },
  {
    id: 2,
    step: '2',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 2 - Potvrdenie registrácie',
  },
  {
    id: 3,
    step: '3',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 3 - Návrh rámcovej zmlúvy',
  },
  {
    id: 4,
    step: '4',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 4 - Dokument súhlas s poskytnutim služby',
  },
  {
    id: 5,
    step: '5',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 5 - Commented',
  },
  {
    id: 6,
    step: '6',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 6 - Vyplnenie Žiadosti o úver',
  },
  {
    id: 7,
    step: '7',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 7 - Odoslanie žiadosti',
  },

  {
    id: 8,
    step: 'select-insurance',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step select-insurance - Poistenie',
  },
  {
    id: 9,
    step: 'confirm-insurance-application',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step confirm-insurance-application - Potvrdenie špecifikácie poistenia',
  },

  {
    id: 10,
    step: 'signing-insurance-application',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step signing-insurance-application - Podpísanie poistnej špecifikácie',
  },
  {
    id: 11,
    step: 'awaiting-acceptance',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step awaiting-acceptance - Čakanie na potvrdenie žiadosti',
  },
  {
    id: 12,
    step: 'awaiting-contract-documentation',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step awaiting-contract-documentation - Čakanie na dokumentáciu',
  },
  {
    id: 13,
    step: '9',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 9 - Návrh Úverovej dokumentácie',
  },
  {
    id: 14,
    step: 'insurance-documentation',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step insurance-documentation - Návrh Poistnej dokumentácie',
  },
  {
    id: 15,
    step: '10',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 10 - Sumárne info o úvere',
  },
  {
    id: 16,
    step: '11',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 11 - Návrh Dohody o zrážkach zo mzdy',
  },
  {
    id: 17,
    step: '12',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 12 - Potvrdenie žiadosti',
  },
  {
    id: 18,
    step: '13',
    loading: false,
    status: 'pending',
    active: false,
    opened: false,
    description: 'step 13 - Úver bol schválený a prechod do zóny',
  },
];

export default onboardingFormData;
